/* model existiert doppelt!! zusammenführen */
export class TransportOption {

  id: number;
  externalKey: string;
  nameDictionaryKey: string;
  hintDriverDictionaryKey: string;
  allwaysShowHint: boolean;
  optional: boolean;
  transportOptions = new Array<TransportOption>();
  minimumSelectedOptions: number;
  columnIndex: number;
  rowIndex: number;
  onlyInternal: boolean;
  color: string;
  messagingReference: string;
  amountOfPallettesMandatory: boolean;
  amountOfBoxesMandatory: boolean;
  amountInKilogrammMandatory: boolean;
  amountInLiterMandatory: boolean;
  amountOthersMandatory: boolean;
  amountMandatoryInTerminal: boolean;
  amountMandatoryInTime: boolean;

  hasParameter: boolean;
  parameterNameDictionaryKey: string;
  readOnlyAtTerminal: boolean;

  parameterValues = new Array<TransportOptionParameterValue>();
  parameter = new Array<TransportOptionParameter>();

  resources = new Array<string>();

  constructor(option?: any) {
    if (option != null) {
      this.id = option.id;
      this.externalKey = option.externalKey;
      this.nameDictionaryKey = option.nameDictionaryKey;
      this.hintDriverDictionaryKey = option.hintDriverDictionaryKey;
      this.optional = option.optional;
      this.minimumSelectedOptions = option.minimumSelectedOptions;
      this.columnIndex = option.columnIndex;
      this.rowIndex = option.rowIndex;
      this.onlyInternal = option.onlyInternal;
      this.color = option.color;
      this.messagingReference = option.messagingReference;
      this.amountOfPallettesMandatory = option.amountOfPallettesMandatory;
      this.amountOfBoxesMandatory = option.amountOfBoxesMandatory;
      this.amountInKilogrammMandatory = option.amountInKilogrammMandatory;
      this.amountInLiterMandatory = option.amountInLiterMandatory;
      this.amountOthersMandatory = option.amountOthersMandatory;
      this.amountMandatoryInTerminal = option.amountMandatoryInTerminal;
      this.amountMandatoryInTime = option.amountMandatoryInTime;
      this.allwaysShowHint = option.allwaysShowHint;
      this.readOnlyAtTerminal = option.readOnlyAtTerminal;

      if (option.resources != null) {
        for (const resource of option.resources) {
          this.resources.push(resource);
        }
      }
      if (option.transportOptions != null) {
        for (const to of option.transportOptions) {
          this.transportOptions.push(new TransportOption(to));
        }
      }

      if (option.parameter != null) {
        for (const parameter of option.parameter) {
          this.parameter.push(new TransportOptionParameter(parameter));
        }
      }

    }
  }
}

export class TransportOptionParameterValue {

  id: number;

  constructor(value?: any) {
    if (value != null) {
      this.id = value.id;
    }
  }

}


export class TransportOptionParameter {

  id: string;
  type: string;

  sortOrder: string;
  minLength: number;
  show: boolean;
  mandatory: boolean;

  parameterValues = new Array<TransportOptionParameterValue>();

  constructor(parameter?: any) {
    if (parameter != null) {
      this.id = parameter.id;
      this.type = parameter.type;
      this.sortOrder = parameter.sortOrder;
      this.minLength = parameter.minLength;
      this.show = parameter.show;
      this.mandatory = parameter.mandatory;
      if (parameter.parameterValues != null) {
        for (const value of parameter.parameterValues) {
          this.parameterValues.push(new TransportOptionParameterValue(value));
        }
      }
    }
  }

}
